const shareTradeEndpoints = {
  setting: '/sharetrade/setting',
  settingAutoShare: '/sharetrade/setting/autoshare',
  target: '/sharetrade/target',
  share: '/sharetrade/share',
};

export default shareTradeEndpoints;
